var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PromotionPage"},[_c('ShPageHeader',{attrs:{"title":("" + (_vm.promotionData.header || '--')),"description":("" + (_vm.promotionData.lead_text || '--')),"breadcrumb-items":[
                  { label: 'zarządzanie' },
                  { label: ("" + (_vm.promotionData.header || '--')), path: '/promotions' }
                ]}}),_c('ShPageLayout',[_c('div',{staticClass:"page-layout",domProps:{"innerHTML":_vm._s(_vm.promotionData.main_box)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }